import React from 'react'
import { ICONS } from '@Const/common'

const HelpMenuClickable = () => (
    <>
        <img src={ICONS.help} alt="help" />
    </>
)

export default HelpMenuClickable
